import { useAdmin, usePermissions } from '@/utils/hooks'
import { PERMISSIONS } from '@/utils/permissions'
import type { ApproveWorkPeriodNode } from './types.graphql'
import { useSalaryModuleConfiguration } from './hooks/useSalaryModuleConfiguration'

export const useWorkPeriodApprovePermissions = () => {
  const { hasPermissions } = usePermissions()
  const admin = useAdmin()
  const salaryModuleConfiguration = useSalaryModuleConfiguration()
  const canConfirmOthers = hasPermissions(
    [
      PERMISSIONS.workPeriod.view.othersworkperiod,
      PERMISSIONS.workPeriod.approve.workperiod,
      PERMISSIONS.workPeriod.change.workperiod,
    ],
    true
  )

  function workPeriodApprovalState(
    meId: string,
    workPeriod: ApproveWorkPeriodNode
  ) {
    const isManager = meId !== workPeriod.user.id && canConfirmOthers
    const driverApproveDirty =
      workPeriod.approvedByUser || workPeriod.userComment
    const managerApproveDirty =
      workPeriod.approvedByManager || workPeriod.managerComment

    const canApproveAsDriver =
      (meId === workPeriod.user.id || admin) &&
      !(
        workPeriod.approvedByManager ||
        !salaryModuleConfiguration.managerApprove
      )
    const canApproveAsManager =
      isManager &&
      (workPeriod.approvedByUser || !salaryModuleConfiguration.driverApprove)

    return {
      driverApproveDirty,
      managerApproveDirty,
      canApproveAsDriver,
      canApproveAsManager,
    }
  }

  return { canConfirmOthers, workPeriodApprovalState }
}
